import React, { useState, useEffect, useRef, useMemo } from "react";
import "./InsightTable.css";
import TopRightActionLinks from "./TopRightActionLinks";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import GenericOverviewSideCard from "../genericComponents/GenericOverviewSideCard";
import Card from "react-bootstrap/Card";
import APP_CONFIG from "../../../config/appConfig";
import TrackerModal from "./Tracker/TrackerModal";
import * as FeatherIcon from "react-feather";
import { Overlay } from "react-bootstrap";
import AIChat from "../Chat/AiChat";
import DomainChip from "../../HtmlElements/DomainChip";
import ParsedTextWithLinks from "../../HtmlElements/ParsedTextWithLinks";
import GenericBubbleChart from "./CompetitorTabs/ProfileMarketPosition/GenericBubbleChart";
import MicroBarChart from "./CompetitorTabs/ProfileMarketPosition/MicroBarChart";
import CategoryBlock from "./CategoryBlock";
import {
  formatBoldText,
  getCustomRowIdentifierLabel,
} from "../../../services/commonService";
import { useParams } from "react-router-dom";
import TabView from "./TabView";
import InfoTooltipIcon from "../../HtmlElements/InfoTooltipIcon";

function InsightTable({
  title,
  subtitle = "",
  belowTableDescription = "",
  data,
  metrics,
  rowIdentifier,
  actions,
  filtersConfig = [],
  extraInsightBlock = [],
  extraIdentifierColumns = [],
  hiddenColumns = [],
  sidecardColumns = [],
  defaultSortColumns = [],
  chartId = "default_bubble_chart",
  chartData = [],
  chartType = "bubble_chart",
  xField = "",
  yField = "",
  nameField = "",
  sizeField = "",
  colorField = "",
  xAxisLabel = "",
  yAxisLabel = "",
  insightsWithArrowBlock = 0,
}) {
  const [activeFilter, setActiveFilter] = useState("All");
  const [isInsightsView, setIsInsightsView] = useState(false);
  const [visibleInsightTypes, setVisibleInsightTypes] = useState([
    "positive",
    "negative",
    "recent",
  ]);
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [showConversationModal, setShowConversationModal] = useState(false);
  const [selectedCompetitor, setSelectedCompetitor] = useState(null);
  const [activeTypes, setActiveTypes] = useState(["filter", "chart"]);
  const [showTrackerModal, setShowTrackerModal] = useState(false);
  const [expandedCellKey, setExpandedCellKey] = useState(null);
  const [expandedIdentifierKey, setExpandedIdentifierKey] = useState(null);

  // -------------------------------

  const [isBelowDescExpanded, setIsBelowDescExpanded] = React.useState(false);
  // const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [sortConfig, setSortConfig] = useState(() => {
    if (defaultSortColumns.length > 0) {
      // pick the first default column
      return { key: defaultSortColumns[0], direction: "desc" };
    }
    return { key: null, direction: "asc" };
  });
  const [chatSection, setChatSection] = useState("");
  const isMomentumField = (key) => key.toLowerCase().includes("momentum");
  const isLinkField = (key) => key.toLowerCase().includes("source");
  const [chartView, setChartView] = useState(true);
  const { clientName, competitorName } = useParams();

  // ********************
  const [selectedRow, setSelectedRow] = useState(null);
  const [isSidecardOpen, setIsSidecardOpen] = useState(false);
  // ********************

  // helper to detect if a field is an object that can be used as tooltip payload
  const hasTooltipPayload = (field) =>
    field != null && typeof field === "object" && field.value != null;

  const renderMomentumCell = (val) => {
    if (!val) return "—";

    // If val is an object, extract the value
    const momentumValue = typeof val === "object" ? val.value : val;
    if (!momentumValue) return "—";

    let color = "black";
    if (momentumValue === "Rising") color = "#058516";
    else if (momentumValue === "Cooling") color = "#BA240D";
    else if (momentumValue === "Stable") color = "#1E1C25";

    return <span style={{ color }}>{momentumValue}</span>;
  };

  // const renderLinkCell = (val) => {
  //   if (!val) return "—";

  //   return (
  //     <a
  //       href={val}
  //       style={{ cursor: "pointer", color: "#2d343d" }}
  //       title={val}
  //       target="_blank"
  //     >
  //       {val}
  //     </a>
  //   );
  // };

  const renderLinkCell = (val) => {
    if (!val) return "—";

    // If val is an object, extract the value
    const linkValue = typeof val === "object" ? val.value : val;
    if (!linkValue) return "—";

    return (
      // <a
      //   href={linkValue}
      //   style={{ cursor: "pointer", color: "#2d343d" }}
      //   title={linkValue}
      //   target="_blank"
      //   rel="noopener noreferrer"
      // >
      //   {linkValue}
      // </a>
      <DomainChip url={linkValue} />
    );
  };

  const renderCustomCell = (tableName, columnKey, value, maxSize) => {
    // Example: MarketTable -> market_size -> MicroBarChart
    if (
      (tableName === "Market by Technologyold" ||
        tableName === "Market by Geographyold" ||
        tableName === "Market by Applicationold") &&
      (columnKey === "technology_market_size" ||
        columnKey === "geographic_market_size" ||
        columnKey === "application_market_size")
    ) {
      return (
        <MicroBarChart value={value?.value || value || ""} maxValue={maxSize} />
      );
    } else if (
      tableName === "Customer Segment Analysis" &&
      columnKey === "market_position"
    ) {
      return (
        <div
          style={{
            padding: "5px",
            background: "transparent",
            borderRadius: "12px",
          }}
        >
          <CategoryBlock
            key={value?.value || value || ""}
            text={value?.value || value || ""}
            columnHeading="Market Position"
          />
        </div>
        // value?.value || value || ""
      );
    } else if (
      tableName === "Market Share Analysis" &&
      columnKey === "company_position"
    ) {
      return (
        <div
          style={{
            padding: "5px",
            background: "transparent",
            borderRadius: "12px",
          }}
        >
          <CategoryBlock
            key={value?.value || value || ""}
            text={value?.value || value || ""}
            columnHeading="Company Position"
          />
        </div>
        // value?.value || value || ""
      );
    } else if (
      tableName === "Strategic Leadership Themes" &&
      columnKey === "impact"
    ) {
      if (!value) return "—";

      // If val is an object, extract the value
      const momentumValue = typeof value === "object" ? value.value : value;
      if (!momentumValue) return "—";

      let color = "black";
      if (momentumValue === "High") color = "#058516";
      else if (momentumValue === "Low") color = "#BA240D";
      else if (momentumValue === "Medium") color = "#1E1C25";

      return <span style={{ color }}>{momentumValue}</span>;
    } else if (
      (tableName === "By Technology" ||
        tableName === "By Application" ||
        tableName === "By Geography") &&
      columnKey === "company_position"
    ) {
      return (
        <div
          style={{
            padding: "5px",
            background: "transparent",
            borderRadius: "12px",
          }}
        >
          <CategoryBlock
            key={value?.value || value || ""}
            text={value?.value || value || ""}
            columnHeading="Strength"
          />
        </div>
        // value?.value || value || ""
      );
    } else if (
      (tableName === "By Technology" ||
        tableName === "By Application" ||
        tableName === "By Geography") &&
      columnKey === "company_market_revenue_percentage"
    ) {
      const actualVal =
        typeof value === "object" && value !== null ? value.value : value;
      const numericVal =
        typeof value === "object" && value !== null
          ? parseInt(value.value)
          : parseInt(value);

      let descriptor = "";
      if (numericVal >= 25) {
        descriptor = "HIGH";
      } else if (numericVal >= 10 && numericVal <= 20) {
        descriptor = "MEDIUM";
      } else {
        descriptor = "LOW";
      }

      return `${descriptor} (~${actualVal || 0})`;
    }

    // fallback -> return null so caller knows to continue default chain
    return null;
  };

  // -------------------------------

  // ______________________________________
  const [activeFilters, setActiveFilters] = useState(() => {
    const init = {};
    (filtersConfig || []).forEach((f) => {
      if (f.type === "chips") init[f.key] = f.defaultValue ?? [];
      else init[f.key] = f.defaultValue ?? "All";
    });
    return init;
  });

  // useEffect(() => {
  //   const init = {};
  //   (filtersConfig || []).forEach((f) => {
  //     if (f.type === "chips") init[f.key] = f.defaultValue ?? [];
  //     else init[f.key] = f.defaultValue ?? "All";
  //   });
  //   setActiveFilters(init);
  // }, [filtersConfig]);

  // ++++++++++++++++++++++
  // PAGINATION
  useEffect(() => {
    setCurrentPage(1);
  }, []);

  // ++++++++++++++++++++++

  useEffect(() => {
    const init = {};
    (filtersConfig || []).forEach((f) => {
      if (f.type === "chips") init[f.key] = f.defaultValue ?? [];
      else init[f.key] = f.defaultValue ?? "All";
    });

    setActiveFilters((prev) => {
      const isSame = Object.keys(init).every(
        (key) => JSON.stringify(prev[key]) === JSON.stringify(init[key])
      );
      return isSame ? prev : init;
    });
  }, [filtersConfig]);

  const handleDropdownChange = (filterKey, value) => {
    setActiveFilters((prev) => ({ ...prev, [filterKey]: value }));
  };

  const handleChipToggle = (filterKey, option) => {
    setActiveFilters((prev) => {
      const current = prev[filterKey] || [];
      if (current.includes(option)) {
        return { ...prev, [filterKey]: current.filter((c) => c !== option) };
      }
      return { ...prev, [filterKey]: [...current, option] };
    });
  };

  const clearFilter = (filterKey) => {
    const f = (filtersConfig || []).find((x) => x.key === filterKey);
    setActiveFilters((prev) => ({
      ...prev,
      [filterKey]: f?.type === "chips" ? [] : f?.defaultValue ?? "All",
    }));
  };

  const filteredData = useMemo(() => {
    if (!filtersConfig || filtersConfig.length === 0) return data || [];

    return (data || []).filter((row) => {
      return filtersConfig.every((f) => {
        const raw = row[f.key];
        const cell =
          typeof raw === "object" && raw !== null ? raw.value ?? "" : raw ?? "";

        if (f.type === "chips") {
          const selected = activeFilters[f.key] || [];
          if (!selected || selected.length === 0) return true; // no selection => pass
          // match any selected option (contains)
          return selected.some((s) => String(cell).includes(String(s)));
        } else {
          // dropdown/single-select
          const sel = activeFilters[f.key];
          if (!sel || sel === "All") return true;
          // exact or contains match
          return (
            String(cell) === String(sel) || String(cell).includes(String(sel))
          );
        }
      });
    });
  }, [data, filtersConfig, activeFilters]);

  // +++++++++++++++++++++++++++++++
  const handleSort = (columnKey) => {
    let direction = "asc";
    if (sortConfig.key === columnKey && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: columnKey, direction });
  };

  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return filteredData;

    return [...filteredData].sort((a, b) => {
      let aVal = a[sortConfig.key];
      let bVal = b[sortConfig.key];

      // If value is an object with .value, use that
      if (typeof aVal === "object" && aVal !== null) aVal = aVal.value;
      if (typeof bVal === "object" && bVal !== null) bVal = bVal.value;

      // Try parsing as number if possible
      const aNum = parseFloat(aVal);
      const bNum = parseFloat(bVal);
      if (!isNaN(aNum) && !isNaN(bNum)) {
        return sortConfig.direction === "asc" ? aNum - bNum : bNum - aNum;
      }

      // Fallback to string comparison
      return sortConfig.direction === "asc"
        ? String(aVal).localeCompare(String(bVal))
        : String(bVal).localeCompare(String(aVal));
    });
  }, [filteredData, sortConfig]);

  // Pagination setup
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;

  const totalPages = Math.ceil(sortedData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedData = sortedData.slice(startIndex, endIndex);

  // +++++++++++++++++++++++++++++++

  const handleAiConversation = (title = "") => {
    setChatSection(title);
    setShowConversationModal((prev) => !prev);
  };
  // ______________________________________

  const trackerRef = useRef(null);

  const formatLabel = (str) =>
    str
      .replace(/_/g, " ") // Replace underscores with space
      .replace(
        /\w\S*/g,
        (
          w // Capitalize first character
        ) => w.charAt(0).toUpperCase() + w?.slice(1).toLowerCase()
      );

  // Fallback identifier logic
  const getDefaultRowIdentifiers = (data = []) => {
    if (!data.length) return [];
    const sampleRow = data[0];
    const ignoreSuffixes = [
      "_positive_insight",
      "_negative_insight",
      "_recent_development",
    ];
    const keys = Object.keys(sampleRow).filter(
      (key) => !ignoreSuffixes.some((suffix) => key.endsWith(suffix))
    );
    return keys?.slice(0, 1); // fallback to first key
  };

  const handleCellToggle = (rowIndex, columnKey) => {
    const key = `${rowIndex}-${columnKey}`;
    setExpandedCellKey((prev) => (prev === key ? null : key));
  };

  const handleIdentifierToggle = (rowIndex, key) => {
    const identifier = `${rowIndex}-${key}`;
    setExpandedIdentifierKey((prev) =>
      prev === identifier ? null : identifier
    );
  };

  const resolvedRowIdentifiers = Array.isArray(rowIdentifier)
    ? rowIdentifier
    : rowIdentifier
    ? [rowIdentifier]
    : getDefaultRowIdentifiers(data);

  // Build fast lookup for hidden columns
  const hiddenSet = new Set((hiddenColumns || []).map((h) => String(h)));

  // Row identifier columns that should be shown in TABLE
  const visibleRowIdentifiers = (
    Array.isArray(resolvedRowIdentifiers)
      ? resolvedRowIdentifiers
      : [resolvedRowIdentifiers]
  ).filter((k) => k && !hiddenSet.has(String(k)));

  // Metrics (columns) to show in TABLE
  const visibleMetrics = (metrics || []).filter(
    (m) => m && !hiddenSet.has(String(m.key))
  );

  const toggleInsightType = (type) => {
    setVisibleInsightTypes((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
    );
  };

  const handleReset = () => {
    setChartView(true);
    setIsInsightsView(false);
    setActiveFilter("");
    setActiveTypes(["filter", "chart"]);
  };

  const handleChart = () => {
    setChartView((prev) => {
      const next = !prev;

      if (next) {
        // chart view ON → add "chart"
        setActiveTypes((prevTypes) => [...prevTypes, "chart"]);
      } else {
        // chart view OFF → remove "chart"
        setActiveTypes((prevTypes) =>
          prevTypes.filter((type) => type !== "chart")
        );
      }

      return next;
    });
  };

  const handleBulbClick = () => {
    setChartView(false);
    setIsInsightsView(true);
    setActiveFilter(metrics[0]?.key || "");
    setActiveTypes(["bulb"]);
  };

  const handleTrackerAdd = (selection) => {
    console.log("Tracker selected:", selection);
    setShowTrackerModal(false);
  };

  const extractInsightText = (insight) => {
    if (!insight) return "—";
    if (typeof insight === "string") return insight;
    if (typeof insight === "object" && insight.value) return insight.value;
    return "—";
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (trackerRef.current && !trackerRef.current.contains(event.target)) {
        setShowTrackerModal(false);
      }
    };

    if (showTrackerModal) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showTrackerModal]);

  const formatHeaderLabel = (col) => {
    // col may be string (key) or object { key, label }
    const name =
      typeof col === "string"
        ? col
        : col?.label ?? col?.key ?? String(col ?? "");
    return name.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const getColKey = (col) => {
    // Return actual key to pick from row object
    if (typeof col === "string") return col;
    return col?.key ?? col;
  };

  const stripHtml = (html) => {
    // Safely strip HTML if a string contains markup (ParsedTextWithLinks may output HTML)
    if (typeof html !== "string") return String(html ?? "");
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const extractCellForExport = (row, key) => {
    // row: row object, key: string
    const raw = row?.[key];
    if (raw == null) return "";
    // if object with value -> use .value; else if array -> join; else primitive
    if (typeof raw === "object") {
      // prefer .value if present
      const v = raw?.value ?? raw;
      if (v == null) return "";
      if (Array.isArray(v))
        return v
          .map((x) => (typeof x === "object" ? JSON.stringify(x) : String(x)))
          .join(" | ");
      if (typeof v === "string") return stripHtml(v);
      // fallback - convert to string
      return String(v);
    }
    // primitive
    return String(raw);
  };

  const escapeCsvCell = (text) => {
    // wrap in double quotes and escape internal quotes
    const s = String(text ?? "");
    // If already contains newline/comma/quote, wrap and escape.
    const needWrap = /[,"\n\r]/.test(s);
    const escaped = s.replace(/"/g, '""');
    return needWrap ? `"${escaped}"` : escaped;
  };

  /**
   * Export CSV
   * - title: table title (string)
   * - dataToExport: array of row objects (sorted/filtered data)
   * - rowIdentifiers: array of row-identifier keys (strings)
   * - metricCols: array of metric objects (each must have .key) OR array of strings
   * - sidecardCols: optional array of string keys or objects { key, label }
   */
  const exportTableData = (
    title,
    dataToExport = [],
    rowIdentifiers = [],
    metricCols = [],
    sidecardCols = []
  ) => {
    try {
      if (!Array.isArray(dataToExport) || dataToExport.length === 0) {
        // nothing to export
        return;
      }

      // Normalize metric columns to keys array if objects are passed
      const metricKeys = (metricCols || []).map((m) =>
        typeof m === "string" ? m : m?.key ?? m
      );

      const rowIdKeys = (rowIdentifiers || []).map((k) =>
        typeof k === "string" ? k : k?.key ?? k
      );

      const sideKeys = (sidecardCols || []).map((c) => getColKey(c));

      // Build headers: readable labels
      const headers = [
        ...rowIdKeys.map((k) => formatHeaderLabel(k)),
        ...metricKeys.map((k) => {
          // if metricCols had objects with label, try to find label
          const found = (metricCols || []).find((m) =>
            typeof m === "object" ? m.key === k : false
          );
          return found && found.label ? found.label : formatHeaderLabel(k);
        }),
        ...sideKeys.map((k) => formatHeaderLabel(k)),
      ];

      // Build rows
      const rows = (dataToExport || []).map((row) => {
        const cells = [];
        // row identifiers first
        rowIdKeys.forEach((k) => {
          cells.push(escapeCsvCell(extractCellForExport(row, k)));
        });
        // metric keys next
        metricKeys.forEach((k) => {
          cells.push(escapeCsvCell(extractCellForExport(row, k)));
        });
        // sidecard keys last
        sideKeys.forEach((k) => {
          cells.push(escapeCsvCell(extractCellForExport(row, k)));
        });
        return cells.join(",");
      });

      // Compose CSV text (header + rows)
      const csvText = [headers.map(escapeCsvCell).join(","), ...rows].join(
        "\n"
      );

      // File name: Title (capitalized, no underscores) + timestamp
      const formatTitleForFile = (t) =>
        (t || "Export")
          .replace(/_/g, " ")
          .replace(/\b\w/g, (c) => c.toUpperCase());
      const fileName = `${formatTitleForFile(title)}_${new Date()
        .toISOString()
        .replace(/[:.]/g, "-")}.csv`;

      // Create blob and download (no libraries)
      const blob = new Blob([csvText], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.setAttribute("download", fileName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      // optional: console.warn(err)
      console.error("Export failed", err);
    }
  };

  const renderTableHeader = () => {
    const renderIdentifierHeaders = () =>
      visibleRowIdentifiers.map((k) => (
        <th key={k} onClick={() => handleSort(k)} style={{ cursor: "pointer" }}>
          <div className="custom-resizable-table-th-content">
            {/* {k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())} */}
            {getCustomRowIdentifierLabel(k)}
            {sortConfig.key === k &&
              (sortConfig.direction === "asc" ? " ▲" : " ▼")}
          </div>
        </th>
      ));

    if (!isInsightsView || !activeFilter || activeFilter === "All") {
      return (
        <tr className="custom-resizable-table-header">
          {renderIdentifierHeaders()}
          {visibleMetrics.map((m) => (
            // <th key={m.key}>
            //   <div className="custom-resizable-table-th-content">{m.label}</div>
            // </th>
            <th
              key={m.key}
              onClick={() => handleSort(m.key)}
              style={{ width: m.width || "auto", cursor: "pointer" }}
            >
              <div className="custom-resizable-table-th-content">
                {/* {m.label} {sortConfig.direction === "asc" ? " 🔼" : " 🔽"} */}
                {m.label} {sortConfig.direction === "asc" ? " ▲" : " ▼"}
              </div>
            </th>
          ))}

          {sidecardColumns && sidecardColumns.length > 0 && <th></th>}
        </tr>
      );
    }

    const selected = metrics.find((m) => m.key === activeFilter);
    return (
      <tr className="custom-resizable-table-header">
        {renderIdentifierHeaders()}
        <th>
          <div className="custom-resizable-table-th-content">
            {selected.label}
          </div>
        </th>
        <th style={{ width: "200px" }}>
          <div className="custom-resizable-table-th-content positive_insight_content_td">
            Positive Insight
          </div>
        </th>
        <th style={{ width: "200px" }}>
          <div className="custom-resizable-table-th-content negative_insight_content_td">
            Negative Insight
          </div>
        </th>
        <th style={{ width: "200px" }}>
          <div className="custom-resizable-table-th-content recent_development_content_td">
            Recent Development
          </div>
        </th>
      </tr>
    );
  };

  const renderInsightWithTooltip = (type, shortText, fullInsight) => {
    const fullText = extractInsightText(fullInsight);
    const previewText = extractInsightText(shortText)?.slice(0, 40);

    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip className={`custom-tooltip ${type}-tooltip`}>
            <div>
              <span style={{ fontWeight: 700 }}>
                {type !== "recent_development"
                  ? type.charAt(0).toUpperCase() + type.slice(1)
                  : "Recent Development"}{" "}
                Insight:
              </span>{" "}
              {fullText}
            </div>
          </Tooltip>
        }
      >
        <div className={`insight-tooltip-wrapper ${type}_insight_content`}>
          <span className="insight-short">• {previewText || "—"}</span>
        </div>
      </OverlayTrigger>
    );
  };

  const renderInsightsWithValue = (value, metricKey, row) => {
    return (
      <div>
        <div>{typeof value === "object" ? value?.value : value || "—"}</div>
        {visibleInsightTypes.includes("positive") &&
          renderInsightWithTooltip(
            "positive",
            row[`${metricKey}_positive_insight`]?.value?.slice(0, 40),
            row[`${metricKey}_positive_insight`]
          )}
        {visibleInsightTypes.includes("negative") &&
          renderInsightWithTooltip(
            "negative",
            row[`${metricKey}_negative_insight`]?.value?.slice(0, 40),
            row[`${metricKey}_negative_insight`]
          )}
        {visibleInsightTypes.includes("recent") &&
          renderInsightWithTooltip(
            "recent_development",
            row[`${metricKey}_recent_development`]?.value?.slice(0, 40),
            row[`${metricKey}_recent_development`]
          )}
      </div>
    );
  };

  const renderTableBody = () => {
    // return sortedData?.length > 0 ? (
    //   (sortedData || []).map((row, idx) => {
    return paginatedData?.length > 0 ? (
      (paginatedData || []).map((row, idx) => {
        const renderIdentifierCells = () =>
          (Array.isArray(visibleRowIdentifiers)
            ? visibleRowIdentifiers
            : [visibleRowIdentifiers]
          ).map((key) => {
            const cellValue = row[key];
            const isObject =
              typeof cellValue === "object" && cellValue !== null;
            const displayValue = isObject
              ? cellValue?.value || "—"
              : cellValue || "—";
            const identifier = `${idx}-${key}`;
            const isExpanded = expandedIdentifierKey === identifier;

            return (
              <>
                <td
                  key={key}
                  className="gtr-cell"
                  style={{ minWidth: "100px" }}
                >
                  <div className="gtr-cell-content-container">
                    <div
                      className={`gtr-cell-content clickable-text hover_disable ${
                        isExpanded ? "expanded" : ""
                      }`}
                      onClick={() => handleIdentifierToggle(idx, key)}
                      style={{
                        pointerEvents: "inherit",
                        flexDirection: "column",
                      }}
                    >
                      {/* Main value */}
                      <span>{displayValue.replace(/[\[\]]/g, "")}</span>

                      {/* Extra values */}
                      {/* {(extraIdentifierColumns || []).map((col) => {
                      const val = row[col.key];
                      const formattedVal =
                        typeof val === "object" && val !== null
                          ? val?.value
                          : val;

                      return formattedVal ? (
                        <span
                          key={col.key}
                          style={{
                            color: "silver",
                            fontSize: "12px",
                            display: "inline-block",
                          }}
                        >
                          ({col.label}: {formattedVal})
                        </span>
                      ) : null;
                    })} */}
                      <span style={{ color: "silver", fontSize: "10px" }}>
                        {(extraIdentifierColumns || [])
                          .map((col) => {
                            const val = row[col.key];
                            const formattedVal =
                              typeof val === "object" && val !== null
                                ? val?.value
                                : val;
                            return formattedVal
                              ? `${col.label}: ${formattedVal}`
                              : null;
                          })
                          .filter(Boolean)
                          .join(" | ")}
                      </span>
                    </div>
                  </div>
                </td>
              </>
            );
          });

        const getInsightValue = (insight) => {
          if (typeof insight === "string") return insight;
          if (typeof insight === "object" && insight !== null)
            return insight?.value || "—";
          return "—";
        };

        if (!isInsightsView || !activeFilter) {
          return (
            <tr className="gtr-row" key={idx}>
              {renderIdentifierCells()}
              {visibleMetrics.map((metric) => {
                const val = row[metric.key];
                const cellKey = `${idx}-${metric.key}`;
                const isInsight = [
                  "positive",
                  "negative",
                  "recent_development",
                ].some((t) => metric.key.includes(t));

                // normalised display string and flag for meta
                const hasMeta =
                  typeof val === "object" &&
                  val !== null &&
                  (val.source || val.confidence_score || val.reasoning);
                const displayText =
                  typeof val === "object" && val !== null
                    ? val.value ?? "—"
                    : val ?? "—";
                const isExpanded = expandedCellKey === cellKey;
                let maxSize = "";
                if (
                  (title === "Market by Technology" ||
                    title === "Market by Geography" ||
                    title === "Market by Application") &&
                  (metric.key === "technology_market_size" ||
                    metric.key === "geographic_market_size" ||
                    metric.key === "application_market_size")
                ) {
                  maxSize = Math.max(
                    ...data.map(
                      (d) =>
                        parseFloat(
                          (
                            d.technology_market_size?.value ||
                            d.geographic_market_size?.value ||
                            d.application_market_size?.value ||
                            ""
                          ).replace(/[^0-9.]/g, "")
                        ) || 0
                    )
                  );
                }
                return (
                  <td
                    key={metric.key}
                    className={`gtr-cell ${
                      typeof val === "object" &&
                      (val?.confidence_score ?? 0) >= 0.88
                        ? "icon-appear-on-hover" // High => show ⓘ only on cell hover
                        : "" // Low/Medium => ⓘ always visible
                    } ${
                      typeof val === "object" && val !== null
                        ? val?.confidence_score >= 0.88
                          ? "light_green"
                          : val?.confidence_score >= 0.8
                          ? "light_blue"
                          : "light_red"
                        : "light_blue" || "—"
                    } `}
                    style={{
                      width: metric.width || "auto",
                      backgroundColor:
                        (isMomentumField(metric.key) ||
                          metric.key === "impact") &&
                        (val === "Rising" || val === "High")
                          ? "#f7fbf8"
                          : (isMomentumField(metric.key) ||
                              metric.key === "impact") &&
                            (val === "Cooling" || val === "Low")
                          ? "#fefcf5"
                          : (isMomentumField(metric.key) ||
                              metric.key === "impact") &&
                            (val === "Stable" || val === "Medium")
                          ? "#fafbfd"
                          : "",
                    }}
                  >
                    <div className="gtr-cell-content-container">
                      <div
                        className={`cell-flex ${
                          expandedCellKey === cellKey ? "expanded" : ""
                        }`}
                        style={{ alignItems: "center" }}
                      >
                        {/* LEFT: value (click to expand/shrink) */}
                        <div
                          className={`cell-text ${
                            !isInsight ? "clickable-text" : ""
                          } `}
                          title={!isInsight ? "Click to expand/shrink" : ""}
                          onClick={() => {
                            if (!isInsight) handleCellToggle(idx, metric.key);
                          }}
                          style={{ fontWeight: "400" }}
                        >
                          {/* {typeof val === "object" && val !== null
                            ? val.value || "—"
                            : val || "—"} */}
                          {/* {isMomentumField(metric.key)
                            ? renderMomentumCell(val)
                            : isLinkField(metric.key)
                            ? renderLinkCell(val)
                            : typeof val === "object" && val !== null
                            ? val?.value || "—"
                            : val || "—"} */}

                          {renderCustomCell(title, metric.key, val, maxSize) ??
                            (isMomentumField(metric.key)
                              ? renderMomentumCell(val)
                              : isLinkField(metric.key)
                              ? renderLinkCell(val)
                              : typeof val === "object" && val !== null
                              ? formatBoldText(
                                  val?.value ? (
                                    <ParsedTextWithLinks text={val?.value} />
                                  ) : (
                                    ""
                                  )
                                ) || "—"
                              : formatBoldText(
                                  val ? <ParsedTextWithLinks text={val} /> : ""
                                ) || "—")}
                        </div>

                        {/* RIGHT: info icon (kept inline, does NOT toggle expand) */}
                        {/* {typeof val === "object" && val?.source && (
                          <button
                            type="button"
                            className="info-btn"
                            onClick={(e) => e.stopPropagation()}
                            onMouseEnter={(e) =>
                              openInfo(e, {
                                source: val.source,
                                confidence_score: val.confidence_score,
                                data_type: val.data_type,
                                reasoning: val.reasoning,
                              })
                            }
                            onMouseLeave={scheduleCloseInfo}
                            aria-label="More info"
                          >
                            <FeatherIcon.Info
                              className="fa"
                              style={{ width: 13 }}
                            />
                          </button>
                        )} */}

                        {/* show info icon on the chip if a sample payload (object) exists */}
                        {hasTooltipPayload(val) && (
                          <InfoTooltipIcon payload={val} from={title} />
                        )}
                      </div>
                    </div>
                  </td>
                );
              })}

              {sidecardColumns.length > 0 && (
                <td className="gtr-cell action-cell">
                  <button
                    className="view_more_custom"
                    onClick={() => {
                      setSelectedRow(row);
                      setIsSidecardOpen(true);
                    }}
                  >
                    View More
                    <FeatherIcon.ArrowRight className="arrow_icon_view_more" />
                  </button>
                </td>
              )}
            </tr>
          );
        }

        if (activeFilter === "All") {
          return (
            <tr className="gtr-row" key={idx}>
              {renderIdentifierCells()}
              {visibleMetrics.map((metric) => (
                <td key={metric.key} className="gtr-cell">
                  <div className="gtr-cell-content-container">
                    {/* <div className="gtr-cell-content">
                    {renderInsightsWithValue(
                      getInsightValue(row[metric.key]),
                      metric.key,
                      row
                    )}
                  </div> */}

                    <td key={metric.key} className="gtr-cell">
                      <div
                        className="gtr-cell-content-container"
                        style={{
                          maxHeight: "none",
                          overflow: "hidden",
                          textOverflow: "unset",
                          whiteSpace: "normal",
                        }}
                      >
                        <div
                          className="gtr-cell-content"
                          style={{
                            display: "block",
                            whiteSpace: "normal",
                            overflow: "visible",
                          }}
                        >
                          {renderInsightsWithValue(
                            getInsightValue(row[metric.key]),
                            metric.key,
                            row
                          )}
                        </div>
                      </div>
                    </td>
                  </div>
                </td>
              ))}
            </tr>
          );
        }

        return (
          <tr className="gtr-row" key={idx}>
            {renderIdentifierCells()}
            <td
              className={`gtr-cell ${
                typeof row[activeFilter] === "object" &&
                (row[activeFilter]?.confidence_score ?? 0) >= 0.88
                  ? "icon-appear-on-hover" // High => show ⓘ only on cell hover
                  : "" // Low/Medium => ⓘ always visible
              }`}
            >
              <div className="gtr-cell-content-container">
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    maxHeight: 40,
                    paddingRight:
                      row[activeFilter] && typeof row[activeFilter] === "object"
                        ? 44
                        : 12,
                  }}
                >
                  {/* left text */}
                  <div
                    style={{
                      fontWeight: "400",
                      fontSize: "12px",
                      lineHeight: "15px",
                      flex: 1,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp:
                        expandedCellKey === `${idx}-${activeFilter}`
                          ? "unset"
                          : 4,
                      whiteSpace:
                        expandedCellKey === `${idx}-${activeFilter}`
                          ? "normal"
                          : "initial",
                    }}
                    onClick={() => handleCellToggle(idx, activeFilter)}
                    className={`gtr-cell-content ${
                      expandedCellKey === `${idx}-${activeFilter}`
                        ? "expanded"
                        : ""
                    } clickable-text`}
                    title={
                      typeof row[activeFilter] === "object"
                        ? row[activeFilter]?.value
                        : row[activeFilter]
                    }
                  >
                    {typeof row[activeFilter] === "object"
                      ? row[activeFilter]?.value || "—"
                      : row[activeFilter] || "—"}
                  </div>

                  {/* right icon, stop propagation */}
                  <div
                    style={{
                      position: "absolute",
                      right: 8,
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {/* show info icon on the chip if a sample payload (object) exists */}
                    {hasTooltipPayload(row[activeFilter]) && (
                      <InfoTooltipIcon payload={row[activeFilter]} />
                    )}
                  </div>
                </div>
              </div>
            </td>

            {[
              { key: "positive", field: "positive_insight" },
              { key: "negative", field: "negative_insight" },
              { key: "recent_development", field: "recent_development" },
            ].map(({ key, field }) => {
              const insight = row[`${activeFilter}_${field}`];
              const val = getInsightValue(insight);
              return (
                <td key={key} className="gtr-cell">
                  <div className="gtr-cell-content-container">
                    <div className="gtr-cell-content">
                      {renderInsightWithTooltip(
                        key,
                        val?.slice?.(0, 40) || "—",
                        val || "—"
                      )}
                    </div>
                  </div>
                </td>
              );
            })}
          </tr>
        );
      })
    ) : (
      <>
        <tr>
          <td style={{ textAlign: "center" }}>
            <div className="no_data_block">
              No {title} data available publicly
            </div>
          </td>
        </tr>
      </>
    );
  };

  return (
    <>
      <div className="mb-2">
        <div className="table_head_block">
          <div className="table_subblock_left">
            <h5 className="table_head">{title}</h5>
            <p className={`table_para ${subtitle === "" ? "d-none" : ""}`}>
              {subtitle}
            </p>
          </div>

          <div
            style={{
              position: "relative",
              display: "inline-block",
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "end",
            }}
          >
            <TopRightActionLinks
              actions={[
                { type: "filter", title: "Table View", onClick: handleReset },
                ...(chartData?.data_set?.length > 0
                  ? [
                      {
                        type: "chart",
                        title: "Chart View",
                        onClick: handleChart,
                      },
                    ]
                  : []),
                // { type: "bulb", title: "Insights", onClick: handleBulbClick },
                ...((sortedData.length > 0 && actions) || []).map((action) =>
                  action.type === "conversation"
                    ? {
                        ...action,
                        onClick: () => {
                          handleAiConversation(title);
                        },
                      }
                    : action.type === "mindMap"
                    ? {
                        ...action,
                        title: "Tracker",
                        onClick: () => setShowTrackerModal(true),
                      }
                    : action.type === "download"
                    ? {
                        ...action,
                        title: "Export",
                        onClick: () =>
                          exportTableData(
                            title,
                            sortedData,
                            visibleRowIdentifiers,
                            visibleMetrics,
                            sidecardColumns
                          ),
                      }
                    : action
                ),
              ]}
              activeTypes={activeTypes}
            />
            {showTrackerModal && (
              <div ref={trackerRef}>
                <TrackerModal
                  trackerData={APP_CONFIG?.defaultCategories}
                  onTrack={handleTrackerAdd}
                  onClose={() => setShowTrackerModal(false)}
                />
              </div>
            )}
          </div>
        </div>

        {chartData?.data_set?.length > 0 &&
        chartType === "bubble_chart" &&
        chartView ? (
          <div
            style={{
              marginBottom: "10px",
              border: "1px solid #98A4AA33",
              borderRadius: "10px",
              padding: "10px",
            }}
          >
            <GenericBubbleChart
              graph_id={chartId}
              graph_height={300}
              graph_data={chartData}
              xField={xField}
              yField={yField}
              nameField={nameField}
              sizeField={sizeField}
              colorField={colorField}
              xAxisLabel={xAxisLabel}
              yAxisLabel={yAxisLabel}
            />
          </div>
        ) : (
          ""
        )}

        {insightsWithArrowBlock == 1 && (
          <div className="new_arrow_blocks_wrapper mb-3">
            <div className="insight_block">
              <h5 className="insight_head">Global Operations Network</h5>
            </div>

            <div className="arrow_blocks">
              <div className="red_blocks" style={{ textAlign: "left" }}>
                <h5 className="head">Raw Material Imports</h5>
                <p className="text_black">
                  <ul style={{ padding: "0px" }}>
                    <li>
                      EVA resin:{" "}
                      <span style={{ fontWeight: "400" }}>
                        Total Imports (Oct 2023 – Sep 2024) - 414 shipments
                        <br /> U.S. Gulf Coast benchmark: ~$1,875/MT FOB
                        (mid-2025 market data)
                      </span>
                    </li>
                    <li>
                      Polyether polyols:{" "}
                      <span style={{ fontWeight: "400" }}>
                        Total Imports (Oct 2023 – Sep 2024) - 762
                        <br /> shipment. U.S. benchmark: ~$2,100/MT FOB
                      </span>
                    </li>
                    <li>
                      Tackifier resins:
                      <span style={{ fontWeight: "400" }}>
                        {" "}
                        Total Imports (Jun 2024 – May 2025) - 600 shipments
                        <br /> Asia benchmark (China/Korea): ~$2,700/MT FOB
                      </span>
                    </li>
                  </ul>
                </p>
                <br />
                {/* <p
                  style={{
                    wordBreak: "break-all",
                    color: "grey",
                    fontSize: "12px",
                  }}
                >
                  <i>
                    Note: These are market reference prices, not TCP-specific
                    purchase costs.
                    <br /> Actual supplier contracts and landed costs are
                    undisclosed.
                  </i>
                </p> */}
              </div>

              <div className="arrow_subblock">
                <p className="arrow_icon">
                  {" "}
                  <img
                    src="/img/arrow_blue.png"
                    alt="icon"
                    className="chip_icon"
                  />
                </p>
              </div>

              <div className="blue_blocks" style={{ textAlign: "left" }}>
                <h5 className="head">Manufacturing Hub</h5>
                <p className="text_black">
                  <ul style={{ padding: "0px" }}>
                    <li>
                      Hickory, NC (HQ):{" "}
                      <span style={{ fontWeight: "400" }}>
                        2 facilities (135,000 sq ft confirmed by company)
                      </span>
                    </li>
                    <li>
                      Hickory, NC (Plant 3):{" "}
                      <span style={{ fontWeight: "400" }}>
                        1 facility (~100,000 sq ft est.)
                      </span>
                    </li>
                    <li>
                      Hickory, NC (Plant 4):
                      <span style={{ fontWeight: "400" }}>
                        {" "}
                        1 facility (~90,000 sq ft est.)
                      </span>
                    </li>
                  </ul>
                </p>
                <p
                  style={{
                    wordBreak: "break-all",
                    color: "grey",
                    fontSize: "12px",
                  }}
                >
                  <i>
                    Note: Only HQ square footage is confirmed. Other
                    <br /> facilities are estimates from secondary sources.
                    <br /> Actual supplier contracts and landed costs are
                    undisclosed.
                    {/* <br />
                    <br /> */}
                  </i>
                </p>
              </div>

              <div className="arrow_subblock">
                <p className="arrow_icon">
                  {" "}
                  <img
                    src="/img/arrow_blue.png"
                    alt="icon"
                    className="chip_icon"
                  />
                </p>
              </div>

              <div className="green_blocks" style={{ textAlign: "left" }}>
                <h5 className="head">Distribution</h5>
                <p className="text_black">
                  <ul style={{ padding: "0px" }}>
                    <li>
                      Direct:{" "}
                      <span style={{ fontWeight: "400" }}>
                        Likely regional truckload/LTL shipments from Hickory hub
                        <br />
                        (industry-est. 400–600 mile radius)
                      </span>
                    </li>
                    <li>
                      Distributors:{" "}
                      <span style={{ fontWeight: "400" }}>
                        Not disclosed publicly
                      </span>
                    </li>
                    <li>
                      Export:
                      <span style={{ fontWeight: "400" }}>
                        {" "}
                        No explicit export program cited
                      </span>
                    </li>
                  </ul>
                </p>
                <p
                  style={{
                    wordBreak: "break-all",
                    color: "grey",
                    fontSize: "12px",
                  }}
                >
                  <i>
                    Note: Distribution model inferred from geography
                    <br /> and industry norms; TCP does not publish
                    distributor/export data.
                  </i>
                </p>
              </div>
            </div>
          </div>
        )}

        {/* _____________________________________ */}
        {/* --- Filters area (table view only) --- */}
        {!isInsightsView && filtersConfig?.length > 0 && (
          <div className="general_filter_block">
            {filtersConfig.map((f) => (
              <div
                className="general_filter_subblock"
                key={f.key}
                // style={{ minWidth: f.type === "dropdown" ? 160 : "auto" }}
              >
                <div className="general_filter_head">{f.label}</div>

                {f.type === "dropdown" && (
                  <select
                    value={activeFilters[f.key] ?? f.defaultValue ?? "All"}
                    onChange={(e) =>
                      handleDropdownChange(f.key, e.target.value)
                    }
                    className="general_filter_select"
                  >
                    {(f.options || []).map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                )}

                {f.type === "chips" && (
                  <div className="chip_block">
                    {(f.options || []).map((opt) => {
                      const selected = (activeFilters[f.key] || []).includes(
                        opt
                      );
                      return (
                        <button
                          key={opt}
                          onClick={() => handleChipToggle(f.key, opt)}
                          className={`chip_btns ${
                            selected ? "chip_btns_active" : ""
                          }`}
                        >
                          {opt}
                        </button>
                      );
                    })}
                  </div>
                )}

                {/* optional clear/reset for this filter */}
                {/* <div style={{ marginTop: 6 }}>
                    <button
                      onClick={() => clearFilter(f.key)}
                      style={{
                        border: "none",
                        background: "transparent",
                        color: "#666",
                        fontSize: 12,
                        cursor: "pointer",
                      }}
                    >
                      Reset
                    </button>
                  </div> */}
              </div>
            ))}
          </div>
        )}

        {/* _____________________________________ */}

        {isInsightsView && (
          <div className="filter_chips mb-3 d-flex flex-wrap align-items-center">
            {visibleMetrics.map((m) => (
              <button
                key={m.key}
                onClick={() => setActiveFilter(m.key)}
                className={`column_filter_chip ${
                  activeFilter === m.key ? "column_filter_chip_active" : ""
                }`}
              >
                {m.label}
              </button>
            ))}
            <button
              onClick={() => setActiveFilter("All")}
              className={`column_filter_chip ${
                activeFilter === "All" ? "column_filter_chip_active" : ""
              }`}
            >
              All
            </button>

            {activeFilter === "All" && (
              <div className="insight-chip-group ms-2 d-flex align-items-center">
                {[
                  {
                    type: "positive",
                    icon: (
                      <img src="/img/green_smile.png" className="smile_img" />
                    ),
                  },
                  {
                    type: "negative",
                    icon: (
                      <img src="/img/red_smile.png" className="smile_img" />
                    ),
                  },
                  {
                    type: "recent",
                    icon: (
                      <img src="/img/recent_blue.png" className="smile_img" />
                    ),
                  },
                ].map(({ type, icon }) => (
                  <label
                    key={type}
                    className="insight-chip d-flex align-items-center me-2"
                    style={{ padding: "3px 1px 3px 3px", cursor: "pointer" }}
                  >
                    <input
                      type="checkbox"
                      checked={visibleInsightTypes.includes(type)}
                      onChange={() => toggleInsightType(type)}
                      style={{ marginRight: "5px" }}
                    />
                    <span className="smile_span">{icon}</span>
                    {type !== "recent" ? (
                      <span className="smile_divider"> | </span>
                    ) : (
                      ""
                    )}
                  </label>
                ))}
              </div>
            )}
          </div>
        )}

        <div
          className="table-responsive"
          style={{
            border:
              extraInsightBlock &&
              !(
                Array.isArray(extraInsightBlock) &&
                extraInsightBlock.length === 0
              )
                ? "1px solid #E2E8F0"
                : "",
            borderRadius:
              extraInsightBlock &&
              !(
                Array.isArray(extraInsightBlock) &&
                extraInsightBlock.length === 0
              )
                ? "8px"
                : "",
            padding:
              extraInsightBlock &&
              !(
                Array.isArray(extraInsightBlock) &&
                extraInsightBlock.length === 0
              )
                ? "10px"
                : "",
            marginBottom:
              extraInsightBlock &&
              !(
                Array.isArray(extraInsightBlock) &&
                extraInsightBlock.length === 0
              )
                ? "5px"
                : "",
          }}
        >
          {extraInsightBlock &&
            !(
              Array.isArray(extraInsightBlock) && extraInsightBlock.length === 0
            ) && (
              <div
                className="extra-insight-block p-2 mb-3"
                style={{
                  background: "#fff",
                }}
              >
                {/* {typeof extraInsightBlock === "function"
                ? extraInsightBlock()
                : extraInsightBlock} */}
                {/* {activeFilter?.length > 0 ? activeFilter : ""} */}
                {activeFilter?.length > 0 ? "" : ""}
              </div>
            )}

          <table className="custom-resizable-table">
            {/* <table
            className={`custom-table ${
              activeFilter === "All" ? "insight-view-all" : ""
            }`}
          > */}
            <thead>{renderTableHeader()}</thead>
            <tbody>{renderTableBody()}</tbody>
          </table>
        </div>

        {/* +++++++++++++++++++++++++++++++++++++++ */}
        {/* PAGINATION */}

        {totalPages > 1 && (
          <div className="mb-3">
            <div
              className="d-inline"
              style={{ textAlign: "center", color: "#777", fontSize:"13px", }}
            >
              Showing {startIndex + 1}–{Math.min(endIndex, sortedData.length)}{" "}
              of {sortedData.length}
            </div>

            <div
              className="d-inline"
              style={{
                display: "flex",
                float: "right",
                fontSize:"13px"
              }}
            >
              <button
                className="btn btn-sm btn-light mr-1 font13"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              {/* Page numbers */}
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                (num) => (
                  <button
                    key={num}
                    onClick={() => setCurrentPage(num)}
                    className={`btn btn-sm mr-1 font13 ${
                      currentPage === num
                        ? "btn-primary font13"
                        : "font13"
                    }`}
                  >
                    {num}
                  </button>
                )
              )}

              <button
                className="btn btn-sm btn-light font13"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        )}

        {/* +++++++++++++++++++++++++++++++++++++++ */}

        {belowTableDescription && (
          <div
            className="below_table_description"
            style={{
              display: "flex",
              alignItems: "baseline",
              cursor: "pointer",
            }}
            onClick={() => setIsBelowDescExpanded(!isBelowDescExpanded)}
          >
            {/* Icon */}
            <div style={{ margin: "0 8px 0 0" }}>
              <img src="/img/bullseye.png" width="16" />
            </div>

            {/* Text */}
            <div
              className={`below_table_text ${
                isBelowDescExpanded ? "expanded" : "clamped"
              }`}
            >
              {belowTableDescription}
            </div>
          </div>
        )}
      </div>

      {showMoreModal && selectedCompetitor && (
        <GenericOverviewSideCard
          showMoreModal={showMoreModal}
          setShowMoreModal={setShowMoreModal}
          titleForSideCard={
            // <h5>{selectedCompetitor[visibleRowIdentifiers[0]]}</h5>
            // <div className="mem-sc-titl-cont">
            //   <img
            //     className="back-btn-img"
            //     src="/img/backArrow.png"
            //     onClick={() => setShowMoreModal(false)}
            //   />{" "}
            //   <span className="span_memory">
            //     {/* {selectedCompetitor[visibleRowIdentifiers[0]]} ({title}) */}
            //     {visibleRowIdentifiers.map((key, idx) => (
            //       <span key={key}>
            //         {selectedCompetitor[key]}
            //         {idx < visibleRowIdentifiers.length - 1 && " / "}
            //       </span>
            //     ))}{" "}
            //     ({title})
            //   </span>
            // </div>
            <span className="span_memory" style={{ marginLeft: "20px" }}>
              {Array.isArray(visibleRowIdentifiers)
                ? visibleRowIdentifiers
                    .map((key) =>
                      typeof selectedCompetitor[key] === "object"
                        ? selectedCompetitor[key]?.value || "—"
                        : selectedCompetitor[key] || "—"
                    )
                    .filter(Boolean)
                    .join(" / ")
                : selectedCompetitor[visibleRowIdentifiers]}{" "}
              ({title})
            </span>
          }
          comp={
            <div className="">
              <div className="marketcap_growth_block">
                {visibleMetrics.map((metric) => (
                  <div className="market_cap_block">
                    <div className="marketcap_headblock">
                      <p className="marketcap_head">
                        {formatLabel(metric.key)}:
                        <span className="marketcap_number">
                          {/* {selectedCompetitor[metric.key] || "—"} */}
                          {/* {selectedCompetitor[metric.key]?.value || "—"} */}
                          {typeof selectedCompetitor[metric.key] === "object"
                            ? selectedCompetitor[metric.key]?.value || "—"
                            : selectedCompetitor[metric.key] || "—"}
                        </span>
                      </p>
                    </div>
                    <div className="marketcap_pos_neg_block">
                      <div className="markets_pos_block">
                        <Card className="pos_block">
                          <Card.Header className="pos_block_header">
                            Positive Insight
                          </Card.Header>
                          <Card.Body className="pos_block_body">
                            <p className="pos_block_text">
                              {typeof selectedCompetitor[
                                `${metric.key}_positive_insight`
                              ] === "object"
                                ? selectedCompetitor[
                                    `${metric.key}_positive_insight`
                                  ]?.value || "—"
                                : selectedCompetitor[
                                    `${metric.key}_positive_insight`
                                  ] || "—"}
                            </p>
                          </Card.Body>
                        </Card>

                        <Card className="neg_block">
                          <Card.Header className="neg_block_header">
                            Negative Insight
                          </Card.Header>
                          <Card.Body className="neg_block_body">
                            <p className="neg_block_text">
                              {typeof selectedCompetitor[
                                `${metric.key}_negative_insight`
                              ] === "object"
                                ? selectedCompetitor[
                                    `${metric.key}_negative_insight`
                                  ]?.value || "—"
                                : selectedCompetitor[
                                    `${metric.key}_negative_insight`
                                  ] || "—"}
                            </p>
                          </Card.Body>
                        </Card>

                        <Card className="rec_block">
                          <Card.Header className="rec_block_header">
                            Recent Development
                          </Card.Header>
                          <Card.Body className="rec_block_body">
                            <p className="rec_block_text">
                              {typeof selectedCompetitor[
                                `${metric.key}_recent_development`
                              ] === "object"
                                ? selectedCompetitor[
                                    `${metric.key}_recent_development`
                                  ]?.value || "—"
                                : selectedCompetitor[
                                    `${metric.key}_recent_development`
                                  ] || "—"}
                            </p>
                          </Card.Body>
                        </Card>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          }
          minWidthForDrawer="50%"
          disableXbtn={true}
        />
      )}

      {/* Sidecard for extra columns */}
      {isSidecardOpen && selectedRow && (
        <GenericOverviewSideCard
          showMoreModal={isSidecardOpen}
          setShowMoreModal={setIsSidecardOpen}
          onClose={() => setIsSidecardOpen(false)}
          titleForSideCard="Details"
          comp={
            // <TabView
            //   sidecardColumns={sidecardColumns}
            //   selectedRow={selectedRow}
            // />
            <div
              style={{ display: "flex", flexDirection: "column", marginTop:'10px' }}
            >
              {sidecardColumns.map((col) => {
                const val = selectedRow[col];
                const displayVal =
                  typeof val === "object" && val !== null
                    ? val.value
                    : val || "—";

                // Capitalize + remove underscores
                const label = col
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (c) => c.toUpperCase());

                return (
                  <div
                    key={col}
                    style={{
                      margin: "5px 10px",
                      // marginLeft: "5px",
                      // marginRight: "5px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      padding: "12px",
                      backgroundColor: "#fff",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: "600",
                        marginBottom: "6px",
                      }}
                    >
                      {label}
                    </div>
                    <div style={{ fontSize: "13px", color: "#475569", lineHeight:'17px' }}>
                      {displayVal}
                    </div>
                  </div>
                );
              })}
            </div>
          }
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This:{" "}
                    {competitorName
                      ? competitorName
                      : "Tailored Chemical Products"}{" "}
                    {chatSection}
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={chatSection} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </>
  );
}

export default InsightTable;
